import FormRow from 'components/FormRow';
import FormSection from 'components/FormSection';
import { TextAreaWithField } from 'components/TextArea';
import { validateSectionFields } from 'modules/Inquiry/Form/formConditions';
import {
  REAL_ESTATE_FOLLOW_UP_AMOUNT,
  REAL_ESTATE_PROJECT_DEVELOPMENT_DESCRIPTION,
  REAL_ESTATE_PROJECT__FOLLOW_UP,
  REAL_ESTATE_PROJECT,
} from 'modules/Inquiry/Form/formFields';
import { AmountWithField } from 'modules/Inquiry/Form/Steps/FinancingNeed/Amount/Amount';
import { useTranslations } from 'utils/hooks/useTranslations';

export const bfsValidateFollowUpSection = validateSectionFields([
  REAL_ESTATE_PROJECT,
  REAL_ESTATE_FOLLOW_UP_AMOUNT,
  REAL_ESTATE_PROJECT_DEVELOPMENT_DESCRIPTION,
]);

const BFSFollowUpFinancing = () => {
  const t = useTranslations();
  return (
    <FormSection title="" showSectionTitle={false}>
      <FormRow>
        <AmountWithField
          name={REAL_ESTATE_FOLLOW_UP_AMOUNT}
          placeholder={t(
            'pages.financingNeed.sections.followUpFinancing.fields.realEstateFollowUpAmount.placeholder',
          )}
        />
      </FormRow>

      <FormRow>
        <TextAreaWithField
          name={REAL_ESTATE_PROJECT_DEVELOPMENT_DESCRIPTION}
          placeholder={t(
            `pages.financingNeed.sections.detailsOfBuilding.fields.financialObjectDescription.placeholder.${REAL_ESTATE_PROJECT__FOLLOW_UP}`,
          )}
        />
      </FormRow>
    </FormSection>
  );
};

export default BFSFollowUpFinancing;
